import { useTheme } from "next-themes";
import { Toaster as Sonner, toast } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

/**
 * App-wide toast host. Mount once near the root of each app. Styled with the
 * EnviroHub design tokens and synced to the active theme. Trigger toasts
 * imperatively via the re-exported `toast` (or through `reportApiError` in
 * `@envirohub/utils` for API failures).
 */
function Toaster({ ...props }: ToasterProps) {
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      position="top-center"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-surface-container-lowest group-[.toaster]:text-surface-on group-[.toaster]:border group-[.toaster]:border-outline-variant/40 group-[.toaster]:rounded-xl group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-surface-on-variant",
          actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-surface-container group-[.toast]:text-surface-on-variant",
          error:
            "group-[.toaster]:!border-error group-[.toaster]:!bg-error group-[.toaster]:!text-error-on [&_[data-description]]:!text-error-on",
          success:
            "group-[.toaster]:!border-secondary group-[.toaster]:!bg-secondary group-[.toaster]:!text-secondary-on [&_[data-description]]:!text-secondary-on",
        },
      }}
      {...props}
    />
  );
}

export { Toaster, toast };
